import { PaletteMode, Components, Theme } from '@mui/material';
import { themePalette } from '../theme.palette';
import { typographyTokens } from '../typography-tokens';
import dimensions from '../dimensions';

export const MuiFormHelperTextTheme = (
  mode: PaletteMode,
): Components<Theme>['MuiFormHelperText'] => {
  const { componentTokens } = themePalette(mode);
  const { spacing } = dimensions;

  return {
    styleOverrides: {
      root: {
        marginTop: 2,
        display: 'flex',
        alignItems: 'center',
        fontSize: typographyTokens.fontSizes.xs,
        lineHeight: typographyTokens.lineHeights.xs,
        fontFamily: typographyTokens.fontFamilies.sans,
        gap: spacing(0.5),
        letterSpacing: 'normal',
        color: componentTokens.inputs.colors.normal.text.helper.default,
        '&.Mui-error': {
          color: componentTokens.inputs.colors.error.text.helper.default,
          '& .MuiSvgIcon-root': {
            color: componentTokens.inputs.colors.error.text.helper.default,
          },
        },
      },
    },
  };
};
